import { useEffect, useState } from "react";
import "../index.css";
import { add, edit } from "../../../controllers/About/AboutMember";
import { imgSource } from "../../../controllers/API_Object";
const AboutMemberForm = ({ data, refresh, index }) => {
  let [image, setImage] = useState();
  const WrapperId = "AboutMemberFormWrapper";
  const FormId = "AboutMemberForm";
  // let [loading, setLoading] = useState(false);
  let toggleForm = () => {
    setImage();
    refresh();
    document.getElementById(WrapperId).classList.toggle("hide");
    document.getElementById(FormId).reset();
  };
  let formSubmitHandle = (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("file", e.target.img.files[0]);
    add(
      formData,
      e.target.name.value,
      e.target.surname.value,
      e.target.role.value,
      e.target.description.value
    ).then(() => {
      toggleForm();
    });
  };
  let formEditHandle = (e) => {
    e.preventDefault();
    let formData = e.target.img.files[0] ? new FormData() : undefined;
    formData?.append("file", e.target.img.files[0]);
    edit(
      data._id,
      formData,
      e.target.name.value,
      e.target.surname.value,
      e.target.role.value,
      e.target.description.value,
      data
    ).then(() => {
      toggleForm();
    });
  };
  useEffect(() => {
    if (data) {
      setImage(imgSource + data.profile);
    }
  }, [data]);
  return (
    <>
      <div
        className="flex justify-center items-center bg-[#254fc4] text-white h-[35px] cursor-pointer hover:bg-[#8445c3]"
        onClick={() => {
          document.getElementById(WrapperId).classList.toggle("hide");
        }}
      >
        Member
      </div>
      <div
        id={WrapperId}
        className={"FormWrapper " + `${data ? " " : "hide"}`}
        onClick={toggleForm}
      >
        <form
          onClick={(e) => {
            e.stopPropagation();
          }}
          id={FormId}
          className="Form"
          onSubmit={(e) => {
            if (data) {
              formEditHandle(e);
            } else formSubmitHandle(e);
          }}
        >
          <div
            className="closeFormBtn"
            onClick={(e) => {
              e.stopPropagation();
              toggleForm();
            }}
          >
            <img src="/asset/close.png" width={20} alt="Close" />
          </div>
          <label>Profile</label>
          {image && <img src={image} alt="" className="h-[150px]" />}

          <input
            type="file"
            name="img"
            accept="image/png, image/jpeg"
            onChange={(e) => {
              setImage(URL.createObjectURL(e.target.files[0]));
            }}
            required={!data ? true : false}
          />
          <p className="text-slate-600">type: png, jpeg</p>

          <label>Name</label>
          <input
            type="text"
            name="name"
            defaultValue={data ? data.name : ""}
            required
          />
          <label>Surname</label>
          <input
            type="text"
            name="surname"
            defaultValue={data ? data.surname : ""}
            required
          />
          <label>Role</label>
          <input
            type="text"
            name="role"
            defaultValue={data ? data.role : ""}
            required
          />
          <label>Description</label>
          <input
            type="text"
            name="description"
            defaultValue={data ? data.description : ""}
            required
          />
          <div className="wrap-submit">
            <input type="submit" />
          </div>
        </form>
      </div>
    </>
  );
};

export default AboutMemberForm;
